/**
 * HR Center permissions.
 *
 * This app has no real role/claims system yet (see src/features/chat/chat.types.ts's
 * unused `User.role` field) — every "admin-only" check elsewhere in the codebase
 * reads the same raw `isAgencyOwner` localStorage flag inline, in about eight
 * different files. HR Center reuses that flag rather than inventing a new
 * mechanism, but centralizes the read here so it isn't duplicated an eighth-plus-one
 * time and so a real role system can replace this in one place later.
 */
export function isHRAdmin(): boolean {
  try {
    return localStorage.getItem('isAgencyOwner') === 'true';
  } catch {
    return false;
  }
}
